import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { fetchActivePoll } from '../../fetchers/poll-fetchers';
import { parseMutationObject } from '../../utilities';

const useFetchActivePoll = ({ scheduleId, isLive }: { scheduleId: string; isLive: boolean }) => {
  const { data, error, refetch, isLoading } = useQuery(
    [`poll_${scheduleId}`, { scheduleId }],
    fetchActivePoll,
    {
      enabled: !!scheduleId && !!isLive,

      refetchOnWindowFocus: false,
    },
  );
  return {
    data: data?.data,
    isLoading,
    error,
    refetch,
  };
};

export default useFetchActivePoll;
